import React, { useState, useEffect } from "react";
import PaymentService from "../services/paymentService";
import { useHistory } from "react-router-dom";

export const Subscription = () => {
  const [products, setProducts] = useState<any[]>();
  const [paymentURL, setPaymentURL] = useState<any>();
  const history = useHistory();
  useEffect(() => {
    getProducts();
  }, []);

  useEffect(() => {
    if (paymentURL) {
      window.location.href = paymentURL;
    }
  }, [paymentURL]);

  const productClicked = (productEntityId: number) => {
    getCheckoutForm(productEntityId);
  };

  const getCheckoutForm = async (productEntityId: number) => {
    try {
      const response: any = await PaymentService.postProductGetCheckoutForm({
        productEntityId: productEntityId,
      });
      console.log(response);
      if (response.data.status === "success") {
        setPaymentURL(response.data.payWithIyzicoPageUrl);
      }
    } catch (e: any) {}
  };

  //Post verify
  const getProducts = async () => {
    const response = await PaymentService.getProducts();
    setProducts(response.data);
  };
  return (
    <div>
      {products &&
        products.map((product: any, index: number) => {
          return (
            <p
              key={index}
              onClick={() => productClicked(product.productEntityId)}
              // onClick={() =>
              //   history.push(
              //     "/iyzicopayment?productentityid=" + product.productEntityId
              //   )
              // }
            >
              {product.productName}
            </p>
          );
        })}
    </div>
  );
};
